import RpcClass from "../../../../../../../../server/RpcClass.js";


import RpcNotFoundException from "../../../../../../../../server/com/silkplm/engine/rpc/exceptions/RpcNotFoundException.js";

let locale;
if(typeof window !== "undefined") {
    locale = window?.navigator?.userLanguage || window?.navigator?.language || Intl.DateTimeFormat().resolvedOptions().locale;
} else {
    locale= RpcClass.locale = Intl.DateTimeFormat().resolvedOptions().locale;
}

const FULL_CLASS = 'com.silkplm.rpc.plm.services.marketPlace.services.RemoteMessageMethodMarketService';

import LocalDate from "../../../../../../../../server/LocalDate.js";
import LocalDateTime from "../../../../../../../../server/LocalDateTime.js";
import LocalTime from "../../../../../../../../server/LocalTime.js";



class RemoteMessageMethodMarketService extends RpcClass{

    /**
     *  @class RemoteMessageMethodMarketService
     *  @alias module:src/server/com/silkplm/rpc/plm/services/marketPlace/services/RemoteMessageMethodMarketService.RemoteMessageMethodMarketService
     *  
     * */
    constructor(){
        super();


    }






    /** 
     * @async
     * @param masterId {string} 
     * @param inquiryType {string} 
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInternalException.RpcInternalException}
     * @returns {Promise<module:src/server/com/silkplm/model/plm/chat/ChatMessageBase.ChatMessageBase[]>}
     */
     filterChatMessageBase(masterId, inquiryType) {
            return RpcClass.rpcCall('/rpc/plm/services/market-place/services/remote-message-method-market-service/filter-chat-message-base', [masterId, inquiryType]);
    }
    /** 
     * @async
     * @param masterId {string} 
     * @param inquiryType {string} 
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInternalException.RpcInternalException}
     * @returns {Promise<module:src/server/com/silkplm/model/plm/chat/ChatMessageInquiry.ChatMessageInquiry[]>}
     */
     filterChatMessageInquiry(masterId, inquiryType) {
            return RpcClass.rpcCall('/rpc/plm/services/market-place/services/remote-message-method-market-service/filter-chat-message-inquiry', [masterId, inquiryType]);
    }
    /** 
     * @async
     * @param entityId {string} 
     * @param message {string} 
     * @param user {string} 
     * @param inquiryType {string} 
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInternalException.RpcInternalException}
     * @returns {Promise<*>}
     */
     sendMessageToBase(entityId, message, user, inquiryType) {
            return RpcClass.rpcCall('/rpc/plm/services/market-place/services/remote-message-method-market-service/send-message-to-base', [entityId, message, user, inquiryType]);
    }
    /** 
     * @async
     * @param entityId {string} 
     * @param message {string} 
     * @param user {string} 
     * @param inquiryType {string} 
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInternalException.RpcInternalException}
     * @returns {Promise<*>}
     */
     sendMessageToInquiry(entityId, message, user, inquiryType) {
            return RpcClass.rpcCall('/rpc/plm/services/market-place/services/remote-message-method-market-service/send-message-to-inquiry', [entityId, message, user, inquiryType]);
    }


    /** @returns {string} */
    getRemoteClass(){
        return FULL_CLASS;
    }
}



let metadata = {};

metadata.__type__ = 'com.silkplm.rpc.plm.services.marketPlace.services.RemoteMessageMethodMarketService';
metadata.__type_short__ = 'RemoteMessageMethodMarketService';
RemoteMessageMethodMarketService.prototype.__metadata__ = metadata;

RemoteMessageMethodMarketService.prototype.__cls__ = FULL_CLASS;

/** @module src/server/com/silkplm/rpc/plm/services/marketPlace/services/RemoteMessageMethodMarketService */
export default RemoteMessageMethodMarketService

export { RemoteMessageMethodMarketService }
